import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const getAllEvaluations = user => {
  return requestWithPromise(
    '/api/evaluation-internships',
    HttpMethods.GET,
    null,
    user
  )
}

export const getInternshipStudentEvaluations = (user, internship) => {
  return requestWithPromise(
    `/api/internships/${getIdOrNull(internship)}/student/evaluations`,
    HttpMethods.GET,
    null,
    user
  )
}
